<!-- 后台-站点管理 -->
<template>
  <div class="user_service-page" v-cloak>
    <van-nav-bar :border="false" left-arrow fixed title="商户-设备管理" class="user_work_order_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #2998FF; color:#FFFFFF;'"></van-nav-bar>
    <!-- 列表 -->
    <van-sticky :offset-top="46" :z-index="11">
      <div class="header-table">
        <p>所属站点
        </p>
        <p v-if="queryForms.station_name" @click="showPicker = true">{{queryForms.station_name}}
          <van-icon name="arrow-down" />
        </p>
        <p v-else @click="showPicker = true">全部
          <van-icon name="arrow-down" />
        </p>
      </div>
    </van-sticky>

    <!-- 列表 -->
    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
        <div class="item" v-for="(item, index) in list" :key="index">

          <!-- 内容 -->
          <div class="center-block">
            <p class="tips"><span>设备名称:{{item.machine_name}}</span>
              <span v-if="item.mac_status == 0" class="kx">{{item.mac_status_name}}</span>
              <span v-if="item.mac_status == 1" class="ml">{{item.mac_status_name}}</span>
              <span v-if="item.mac_status == 2" class="gz">{{item.mac_status_name}}</span>
              <span v-if="item.mac_status == 3" class="jy">{{item.mac_status_name}}</span>
            </p>
            <p class="name">硬件编号:{{item.machine_code}}</p>
            <p class="text">所属站点：{{item.station_name}}</p>
          </div>

        </div>
      </van-list>
    </div>

    <van-empty class="custom-image" v-if="list.length < 1" />

    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar title="充值类型" :columns="poplist" @confirm="onConfirm" value-key="val" @cancel="showPicker = false" />
    </van-popup>
  </div>
</template>

<script type="text/babel">
export default {
  name: "sys-machine-list",
  components: {},
  props: {},
  data() {
    return {
      list: [
        // {
        //   id: "设备id",
        //   machine_name: "设备名称",
        //   machine_code: "设备编码",
        //   mac_status: "设备状态：0空闲 1忙碌 2故障 3禁用",
        //   mac_status_name: "状态名称",
        //   station_name: "站点名称",
        // },
      ],
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,

      showPicker: false, // 类型选择
      poplist: [], //类型选择

      queryForms: {
        station_id: undefined, //
        station_name: undefined, //
      },
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getcofig();
  },
  methods: {
    getList() {
      this.$toast.loading();
      let _this = this;
      let data = {
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this
        .$post(
          "/api/m_machine_list",
          Object.assign(data, this.queryForms),
          Object.assign(data, this.queryForms)
        )
        .then((res) => {
          // console.log(res.data);
          this.$toast.clear();
          _this.loading = false; // 加载状态结束

          if (res.data.code == 0) {
            // console.log(res.data.data);
            let lists = res.data.data;

            if (lists && lists.length > 0) {
              if (_this.pageNum == 1) {
                _this.list = [];
                _this.list = lists;
              } else {
                _this.list = _this.list.concat(lists);
              }
              _this.pageNum++;
              if (lists.length < _this.pageSize) {
                _this.finished = true; // 数据全部加载完成
              }
            } else {
              console.log("444");
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            console.log("555");
            _this.$toast.fail(res.data.message);
            _this.finished = true;
          }
        });
    },
    getcofig() {
      let _this = this;
      let data = {
        page: 1,
        limit: 10000,
      };
      _this.$post("/api/m_station_list", data, data).then((res) => {
        console.log(res);

        if (res.data.code == 0) {
          console.log(res.data.data);

          var list = res.data.data;
          var array = [];

          array = list.map((item, index) => ({
            key: item.id,
            val: item.station_name,
          }));

          // array = list.map((val) => ({
          //   key: val,
          //   val: list[val],
          // }));
          console.log(array);

          _this.poplist = array;
          this.queryForms = {
            station_id: array[0].key, //
            station_name: array[0].val, //
          };
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    onConfirm(value, index) {
      console.log(value, index);
      this.showPicker = false;
      this.queryForms = {
        station_id: value.key, //
        station_name: value.val, //
      };
      this.list = [];
      this.pageNum = 1;
      this.loading = true;
      this.finished = false;
      this.getList();
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.user_service-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
.user_work_order_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
</style>


<style lang="scss" scoped>
.user_service-page {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f7f7f7;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  .list {
    padding: 0 10px;
  }

  //   0空闲 1忙碌 2故障 3禁用",
  .ml {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #f98d23;
  }
  .kx {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #3f7cff;
  }
  .gz {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #eb2e2e;
  }
  .jy {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ccc;
  }

  .header-table {
    height: 54px;
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }
  .item {
    margin: 15px 0;
    background-color: #fff;
    box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.06);
    // overflow: hidden;
    border-radius: 5px;
    // 内容模块
    .center-block {
      width: 100%;
      height: 100%;
      // background-color: #eee;
      display: flex;
      flex-direction: column;
      justify-content: center;

      padding: 15px;

      .tips {
        font-size: 15px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: Source Han Sans CN;
        color: #333333;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .name {
        font-size: 12px;

        font-family: Source Han Sans CN;
        margin-bottom: 10px;
        font-weight: 500;
        // line-height: 26px;
        color: #cccccc;
        text-align: left;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
      .text {
        text-align: left;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 17px;
        color: #cccccc;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 3; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
    }
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
</style>
